export const getDomainNameFromHostname = (hostName: string): string => {
  return hostName.substring(hostName.lastIndexOf('.', hostName.lastIndexOf('.') - 1) + 1);
};
